// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PReadOutlinedSvg from "@fishx/icons-svg/es/asn/PReadOutlined";
import FishxIcon from '../components/FishxIcon';

var PReadOutlined = function PReadOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PReadOutlinedSvg
  }));
};

PReadOutlined.displayName = 'PReadOutlined';
export default React.forwardRef(PReadOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PReadOutlined.js
// module id = 3577
// module chunks = 0